<template>
    <div class="same-member-product" @click.self="close">
        <div class="main">
            <img class="close" @click="close" src="https://appd.knowbox.cn/ss/activity/common/icon_popup_close.png"/>
            <img class="happy-ele" src="https://appd.knowbox.cn//ss/activity/parent_frontend/member/happy-ele.png" alt="">
            <p class="title">开通套餐成功</p>
            <p class="ctn">您已开通该套餐</p>
            <p class="ctn">快去享受优质会员权益吧</p>
            <button @click="close">知道了</button>
        </div>
    </div>
</template>

<script>
import utils from "@/assets/js/utils";
const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');
export default {
  name: "",
  props: {
    // 是否升级,1是 0否,如果是1时
    needUpgrade: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {};
  },
  created() {
    utils.sendLog(
        {
            token: token,
            version: version,
            source: source
        },
        "vipCancleOpen_show"
    );
  },
  methods: {
    close() {
      this.$emit("toggleMemberProductPopup");
    }
  }
};
</script>

<style lang="scss" scoped>
.same-member-product {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.8);
  position: fixed;
  top: 0;
  left: 0;
  .main {
    position: absolute;
    top: calc(50% + 0.94rem);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5.8rem;
    height: 4.75rem;
    border-radius: 0.3rem;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .happy-ele {
      position: absolute;
      width: 4.04rem;
      height: 1.95rem;
      top: -1.95rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .title {
      width: 100%;
      font-family: "FZY4JW--GB1-0";
      font-size: 0.4rem;
      line-height: 1rem;
      color: #fff;
      height: 1rem;
      font-weight: bolder;
      background-color: #ffc92c;
      border-radius: 0.3rem 0.3rem 0 0;
      margin-bottom: .8rem;
      position: relative;
      &::before{
          content: "";
          width: .38rem;
          height: 1rem;
          background: url(https://appd.knowbox.cn//ss/activity/parent_frontend/member/colour1.png) no-repeat;
          background-size: 100% 100%;
          position: absolute;
          left: -.38rem;
          top: .35rem;
      }
      &::after{
          content: "";
          width: .38rem;
          height: 1rem;
          background: url(https://appd.knowbox.cn//ss/activity/parent_frontend/member/colour2.png) no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: -.38rem;
          top: .35rem;
      }
    }
    .ctn {
      	font-family: PingFangSC-Medium;
        font-size: .32rem;
        line-height: .52rem;
        letter-spacing: 0px;
        color: #7b531e;
    }
    .course {
      font-size: 0.32rem;
      color: #7b531e;
      height: 2.66rem;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      margin-top: 0.31rem;
      font-weight: bolder;
      div {
        display: flex;
        align-items: center;
        img {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.26rem;
        }
      }
    }
    button {
      width: 4.4rem;
      height: 0.88rem;
      border-radius: 0.44rem;
      font-family: "PingFangSC-Medium";
      font-size: 0.32rem;
      color: #7b531e;
      margin-top: 0.56rem;
      background-image: linear-gradient(
        to right,
        rgb(233, 205, 149),
        rgb(241, 219, 178)
      );
    }
    .close {
      width: 0.61rem;
      height: 0.62rem;
      position: absolute;
      top: 0;
      right: 0;
      background: rgba($color: #fff, $alpha: 0.8);
      border-radius: 0 0.3rem 0 0.61rem ;
    }
  }
}
</style>